export default "__VITE_ASSET__DHzj_39k__"